var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75L4.5 19.5",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4659 2.78429L8.62528 8.62492C8.62528 8.62492 6.0284 7.32179 3.24403 9.57179C3.16209 9.63809 3.09506 9.72092 3.04729 9.81487C2.99951 9.90882 2.97208 10.0118 2.96677 10.117C2.96146 10.2223 2.9784 10.3275 3.01648 10.4258C3.05456 10.5241 3.11293 10.6132 3.18778 10.6874L13.294 20.7937C13.3697 20.8706 13.4611 20.9304 13.5619 20.9688C13.6628 21.0072 13.7707 21.0234 13.8784 21.0163C13.9861 21.0092 14.091 20.9789 14.1859 20.9276C14.2808 20.8762 14.3635 20.8049 14.4284 20.7187C15.2159 19.678 16.4534 17.5218 15.3753 15.3749L21.2159 9.53429C21.2868 9.46451 21.343 9.38132 21.3815 9.28958C21.4199 9.19784 21.4396 9.09938 21.4396 8.99992C21.4396 8.90046 21.4199 8.802 21.3815 8.71025C21.343 8.61851 21.2868 8.53533 21.2159 8.46554L15.5347 2.78429C15.4649 2.71343 15.3817 2.65715 15.2899 2.61874C15.1982 2.58033 15.0997 2.56055 15.0003 2.56055C14.9008 2.56055 14.8024 2.58033 14.7106 2.61874C14.6189 2.65715 14.5357 2.71343 14.4659 2.78429Z",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushpin);
export default __webpack_public_path__ + "static/media/pushpin.7f0089db8b6cc57fa95d8b777ae5a1ef.svg";
export { ForwardRef as ReactComponent };